app.mediator.registerModule(MODULE_NAME__SIGN_IN_FORM, function (app) {

    var dataStore = app.data;

    return {

        // The jQuery DOM element that is the register form
        $formElem: null,

        // The JDA validator object - a wrapper around validateJS. Created on init().
        jdaValidator: null,

        isDomLoaded: false,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
                this.isDomLoaded = true;
            }
        },

        init: function () {
            // Init

            // Prepare data for creation of jda validator instance
            var baseConstraints = dataStore.get('validation.signInForm');
            this.$formElem = $('#form-sign-in');

            // Don't bother to add the event listeners if the form DOM element does not exist
            // i.e. We are on another page. This will save memory.
            if (!this.$formElem.length) return;

            // Create jda validator instance
            this.jdaValidator = app.validator.build({}, this.$formElem);

            // Add constraints data to validator
            this.jdaValidator.constraintBag.addConstraints(baseConstraints);

            this.addDomListeners();

            app.mediator.notify(EVENT_NAME__SIGN_IN_FORM__INITIATED);
        },

        addDomListeners: function () {
            var scope = this;

            // Adjust this element's validation messages on input change
            this.$formElem.find('input[type=password], input[type=text], input[type=email]').keyup(function (e) {
                if (scope.jdaValidator.configuration.keyUpShouldBeIgnored(e)) return;
                var $elem = $(this);
                scope.handleElemChange($elem);
            });

            // On submit, check for validation, then submit
            this.$formElem.submit(function (e) {
                scope.handleFormSubmit(e);
            });
        },

        //==========================================================xdiv2====
        // Module
        //===================================================================

        handleElemChange: function ($elem) {
            var elemId = this.jdaValidator.configuration.getFormFieldId($elem);
            var formFieldId = this.jdaValidator.configuration.getFormFieldId($elem);
            var messageBag = this.jdaValidator.getMessageBagForFormField(formFieldId);
            this.jdaValidator.presenter.clearStatus($elem);
            this.jdaValidator.presenter.showStatus($elem, messageBag);
        },

        handleFormSubmit: function (e) {
            var messageBag = this.jdaValidator.getMessageBag();
            this.jdaValidator.presenter.clearStatuses();
            this.jdaValidator.presenter.showStatuses(messageBag);
            if (messageBag.hasMessages()) {
                e.preventDefault();
                this.jdaValidator.presenter.scrollToFirstError();
                return;
            }
            this.$formElem.find('button[type="submit"]').prop('disabled', true);
        }
    };
});
